import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { JourneySummary } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import { getFormattedDateForApi } from '@/utils/helpers/get-formatted-date-for-api';

interface JourneyListParams {
  status?: string;
  date?: string | Date;
  page?: number;
  sort?: string;
  search?: string;
  limit?: number;
}

type JourneyListQueryOptions = Omit<UseQueryOptions<JourneySummary[]>, 'queryKey' | 'queryFn'>;

const useGetJourneyListData = (
  params: JourneyListParams = {},
  options?: JourneyListQueryOptions
) => {
  const queryKey = ['journeys', 'single', params];

  return useQuery<JourneySummary[]>({
    queryKey,
    queryFn: async () => {
      const apiParams = {
        ...params,
        date: params.date ? getFormattedDateForApi(params.date) : undefined,
      };

      const response = await axiosInstance.get<JourneySummary[]>(
        API_ROUTES.journeyLists(apiParams)
      );

      return response.data;
    },
    enabled: !!params.date,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    ...options,
  });
};

export default useGetJourneyListData;
